export default __webpack_public_path__ + "locales/fr/ChangePortalOwner.json?hash=fad1583a7b4e082780cbbe698d79cca4";